import { render, staticRenderFns } from "./ActivityGroupSidebarSection.vue?vue&type=template&id=19ceeb80&"
import script from "./ActivityGroupSidebarSection.vue?vue&type=script&lang=ts&"
export * from "./ActivityGroupSidebarSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports